// Encrypted external event names
// Without _access suffix — appended automatically by useEncryptedEventsExternal

export const ENCRYPTED_BUTTON_PRESSED_MEDICARE_CONTINUE = 'button_pressed_medicare_continue';
export const ENCRYPTED_BUTTON_PRESSED_ECKM_CONTINUE = 'button_pressed_eckm_continue';
export const ENCRYPTED_BUTTON_PRESSED_CKM_CONTINUE = 'button_pressed_ckm_continue';
export const ENCRYPTED_BUTTON_PRESSED_BEHAVIORAL_HEALTH_CONTINUE = 'button_pressed_behavioral_health_continue';
export const ENCRYPTED_BUTTON_PRESSED_TRACK_OFFERING_CONTINUE = 'button_pressed_track_offering_continue';
